import {PATH} from '../constants';
import {ERROR_CODE} from "../constants/error";


export const handleNavigation = ({navigate, merchantProfile, pathname}) => {
    if (!merchantProfile?.success) {
        // window.localStorage.removeItem(LOCAL_STORAGE_KEY.TOKEN);
        navigate(PATH.LOGIN)
    } else if (merchantProfile?.data?.code === ERROR_CODE['MERCHT-05']) {
        navigate(PATH.ONBOARDING)
    } else if (pathname === PATH.ONBOARDING) {
        navigate(PATH.MANAGING_PRODUCT);
    } else if (pathname === PATH.LOGIN) {
        navigate(PATH.HOME);
    }
}
